import { IRoutesProvider } from 'Shared/Routes';
import { lazy } from 'solid-js';
import { GeneralRedirect } from 'Shared/Routes';
import { Environment } from 'Common/Environment';


/* This is just used for venue logins via voshub */
export class LoginRoutes implements IRoutesProvider
{
	constructor(
		readonly build:Environment
	) {}

	routes()
	{
		return ([
			{
				path: '/login',
				component: lazy(() => import('Shared/users/LoginPage')),
			},
			/*
				Not really intended for use, but in case someone goes to voshub.com directly.
				It is quite a slow roundabout login.
			*/
			{
				path: '/',
				component: () => <GeneralRedirect url={this.build.artistRegoUrl} />,
			},

			...sharedLoginRoutes()
		]);
	}
}	


/* Routes shared with artist GUI */
export function sharedLoginRoutes()
{
	return [
		{
			path: '/forgotPassword',
			component: lazy(() => import('Shared/users/ForgotPasswordPage')),
		},
		{
			path: '/resetPassword/:key',
			component: lazy(() => import('Shared/users/ResetPasswordPage')),
		},
		{
			path: '/setPasswordAtRegistration/:key',
			component: lazy(() => import('Shared/users/SetPasswordAtRegistrationPage')),
		},
	];
}
